import { CheckSquare } from "lucide-solid";
import { cn } from "@listto/shared";

interface LogoProps {
  size?: "sm" | "lg";
  class?: string;
}

export function Logo(props: LogoProps) {
  const size = () => props.size ?? "sm";

  return (
    <div
      class={cn(
        "flex items-center gap-3 select-none",
        size() === "lg" && "flex-col gap-4 text-center",
        props.class,
      )}
    >
      {size() === "sm" ? (
        <>
          <div class="h-8 w-8 rounded-lg bg-accent shadow-lg shadow-accent/20 flex items-center justify-center shrink-0">
            <CheckSquare class="h-5 w-5 text-accent-foreground" />
          </div>
          <span class="text-xl font-bold tracking-tight bg-clip-text text-transparent bg-gradient-to-br from-foreground to-foreground/70">
            Listto
          </span>
        </>
      ) : (
        <>
          <div class="h-16 w-16 rounded-2xl bg-accent/15 flex items-center justify-center mb-2 shadow-inner shrink-0 transition-transform hover:scale-105 active:scale-95 duration-300">
            <CheckSquare class="h-8 w-8 text-accent" />
          </div>
          <h1 class="text-3xl font-bold tracking-tight bg-clip-text text-transparent bg-gradient-to-br from-foreground to-foreground/80">
            Listto
          </h1>
        </>
      )}
    </div>
  );
}
